// src/components/privacy/ZKPAUnsupportedBrowser.tsx
import { SvgAlertCircle } from "@opal/icons";
import { Text, Button } from "@opal/components";

/**
 * ZKPAUnsupportedBrowser — shown when window.crypto.subtle is not available.
 * Blocks login entirely — ZKPA cannot function without Web Crypto API.
 */
export function ZKPAUnsupportedBrowser() {
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[var(--surface-01)] p-6"
      role="alert"
      aria-live="assertive"
    >
      <div className="max-w-sm text-center space-y-4">
        <SvgAlertCircle
          className="h-12 w-12 text-[var(--status-error-02)] mx-auto"
          aria-hidden="true"
        />
        <Text size="lg" weight="semibold">Trình duyệt không được hỗ trợ</Text>
        <Text size="sm" color="subtle">
          VNP Workplace yêu cầu <strong>Web Crypto API</strong> để bảo vệ dữ liệu của bạn.
          Tính năng này có trên Chrome 37+, Firefox 34+, Safari 11+, Edge 12+.
        </Text>
        <Text size="xs" color="muted">
          Vui lòng cập nhật trình duyệt hoặc chuyển sang trình duyệt khác để tiếp tục.
        </Text>
        <Button
          id="zkpa-unsupported-reload-btn"
          variant="secondary"
          onClick={() => window.location.reload()}
        >
          Thử lại
        </Button>
      </div>
    </div>
  );
}
